import React from 'react';
import './Info.css';
import { MapPinned, Clock3, Baby, Gift, Mail } from 'lucide-react';

import photo2 from '../assets/photo2.png';
import photo4 from '../assets/photo4.png';

export default function Info({ onRsvp, onNavigate }) {
  return (
    <div className="page-wrapper info-page">
      <div className="section-header">
        <span className="section-eyebrow">What You Need to Know</span>
        <h2 className="section-title">Event <em>Information</em></h2>
        <div className="gold-line" />
        <p className="section-subtitle">Everything you need to celebrate with us perfectly.</p>
      </div>

      {/* ── WHEN & WHERE ── */}
      <section className="info-strip">
        <div className="info-strip__header">
          <span className="info-strip__eyebrow">Time and Place</span>
          <span className="info-strip__divider" />
          <h3 className="info-strip__title">When and Where</h3>
        </div>

        <div className="info-strip__grid">
          <div className="info-strip__image-card">
            <img src={photo2} alt="Ayotomide and Ayobami wedding portrait" />
            <div className="info-strip__date-badge">
              <strong>01</strong>
              <span>August</span>
            </div>
          </div>

          <div className="info-strip__merged-card">
            <span className="info-strip__merged-kicker">Style & Moments</span>

            <div className="info-strip__merged-block">
              <h4 className="info-strip__mini-title">Dress Code</h4>
              <p className="info-strip__mini-text">
                The color of the day is olive green. We have caps and gele available, kindly let us know if you'd like any through the RSVP form. We'd love to see everyone dressed beautifully as we celebrate together.
              </p>
            </div>

            <div className="info-strip__merged-line" />

            <div className="info-strip__merged-block">
              <h4 className="info-strip__mini-title">Pictures</h4>
              <p className="info-strip__mini-text">
                Capture every beautiful moment. Please make sure to take a picture with the couple before the ceremony ends.
              </p>
            </div>
          </div>

          <div className="info-strip__detail-card">
            <div className="info-strip__detail-icon">
              <MapPinned size={26} strokeWidth={1.8} />
            </div>

            <h4 className="info-strip__detail-title">The Venue</h4>
            <p className="info-strip__detail-text">
              The Brook, Stratford
              <br />
              London E15 2QT
            </p>

            <div className="info-strip__detail-line" />

            <div className="info-strip__meta">
              <div className="info-strip__meta-item">
                <Clock3 size={16} strokeWidth={1.8} />
                <span>Saturday, 01 August 2026</span>
              </div>
            </div>

            <a
              className="info-strip__map-link"
              href="https://maps.google.com/?q=The+Brook+Stratford+London+E15+2QT"
              target="_blank"
              rel="noreferrer"
            >
              Open in Maps →
            </a>
          </div>

          <div className="info-strip__image-card">
            <img src={photo4} alt="Ayotomide and Ayobami traditional portrait" />
            <div className="info-strip__date-badge">
              <strong>01</strong>
              <span>August</span>
            </div>
          </div>
        </div>
      </section>

      {/* ── BEFORE YOU ARRIVE ── */}
      <section className="info-notes">
        <div className="info-notes__header">
          <span className="info-strip__eyebrow">Guest Notes</span>
          <span className="info-strip__divider" />
          <h3 className="info-strip__title">Before You Arrive</h3>
        </div>

        <div className="info-notes__grid">
          <div className="info-note-card fade-up">
            <div className="info-note-card__icon">
              <Baby size={20} strokeWidth={1.8} />
            </div>
            <h4 className="info-note-card__title">Little Ones</h4>
            <p className="info-note-card__body">
              While we adore your little ones, we’re unable to accommodate babies or very young children who require supervision. Older children are welcome. Thank you for your understanding, and we look forward to sharing a wonderful day together.
            </p>
          </div>

          <div className="info-note-card fade-up">
            <div className="info-note-card__icon">
              <Gift size={20} strokeWidth={1.8} />
            </div>
            <h4 className="info-note-card__title">Gifting</h4>
            <p className="info-note-card__body">
              Your presence is our greatest gift. Please note that no physical gifts will be accepted at the venue. All gifting options are available online.
            </p>
            <a
              className="info-note-card__link"
              href="#gifting"
              onClick={(e) => {
                e.preventDefault();
                onNavigate('gifting');
              }}
            >
              View Gifting Options →
            </a>
          </div>

          <div className="info-note-card fade-up">
            <div className="info-note-card__icon">
              <Mail size={20} strokeWidth={1.8} />
            </div>
            <h4 className="info-note-card__title">Strictly by Invitation</h4>
            <p className="info-note-card__body">
              This event is strictly by invitation only. This ensures we can properly plan catering and seating for every guest, and that each person receives the warmth and attention they deserve.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}